import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../BaseComponent/BaseComponent';


import styles from './Popup.scss';

import CloseButton from "./CloseButton";
import Button from "./Button";


class Popup extends BaseComponent {
	constructor(props) {
		super(props);
		this.state = Object.assign({}, props);
	}

	close = () => {
		this.state.isVisible = false;
		this.setState(this.state);
	};

	onEsc = (event) => {
		if (this.state.isVisible) {
			if (event.keyCode === 27) {
				this.close();
			}
		}
	};

	componentDidMount() {
		super.componentDidMount();
		document.addEventListener('keydown', this.onEsc, false);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.onEsc, false);
	}

	eventConsume(eventName, eventData) {
		if (eventName === 'ShowPopup') {
			const {popupName, replaceField, replaceValue} = eventData;
			if (popupName === this.props.name) {
				let state = this.state;
				if (typeof replaceField === 'string' && typeof replaceValue === 'string') {
					let paragraphs = [];
					this.state.content.paragraphs.map((par) => {
						paragraphs.push(par.replace(replaceField, replaceValue));
					});
					state.content.paragraphs = paragraphs;
				}

				this.state.isVisible = true;
				this.setState(state);
			}
		}
	}

	render() {
		document.body.style.overflow = "auto";
		if (this.state.isVisible) {
			document.body.style.overflow = "hidden"
		}
		let button = (
			<div data-layout="text-center">
				<br/>
				<Button onClick={this.close}
						name={this.props.closeButton}
						value={this.props.closeButton}/>
			</div>
		);
		let popupContent = '';
		if (this.state.content && this.state.isVisible) {
			popupContent =
				<div className={styles.container}>
					<div>
						<div className={styles.closeButton}>
							<CloseButton onClick={this.close} altText={"Close"}/>
						</div>
						<h1>{this.state.content.heading}</h1>
						{
							this.state.content.paragraphs.map((paragraph, key) =>
								<p key={key} dangerouslySetInnerHTML={{__html: paragraph}}/>)
						}

						{this.props.closeButton && button}

					</div>
				</div>;
		}
		return (
			<div>{popupContent}</div>
		);
	}
}

Popup.propTypes = {
	name: PropTypes.string.isRequired,
	isVisible: PropTypes.bool.isRequired,
	content: PropTypes.shape({
		heading: PropTypes.string.isRequired,
		paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired
	}),
	closepopup: PropTypes.func
};

export default Popup;